/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, Injector, OnInit, OnDestroy, PLATFORM_ID, signal, Output, Input } from '@angular/core';
import { assets } from '../../../../core/constants/assets.const';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { UserType, UserTypeService } from '../../../../service/user-type.service';
import { BaseClass } from '../../../../shared/class/BaseClass';
import { Subject, Subscription, takeUntil } from 'rxjs';
import {  takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoginResponse } from '../../../../models/auth.model';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { ConfirmDialogService } from '../../../../service/confirm-dialog.service';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'notchmark-common-layout',
    imports: [ButtonModule, RouterModule,DrawerModule, CommonModule],
    templateUrl: './common-layout.component.html',
    styleUrl: './common-layout.component.scss'
})
export class CommonLayoutComponent extends BaseClass implements OnInit, OnDestroy {
  drawer: boolean = false;
  assetsConst = assets;
  userType: UserType | null = null;
  protected profile = signal<LoginResponse | null>(null);
  protected subscriptionSubject$!: Subscription;
  private destroy = new Subject<void>();
   private confirmationService = inject(ConfirmDialogService);
  private userTypeService = inject(UserTypeService);
  private platformId = inject(PLATFORM_ID);
    @Input() isMobileSidebar: boolean = false; 
  @Output() menuSelected: Subject<boolean> = new Subject<boolean>();

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(injector: Injector) {
    super(injector);
    
    this.subscriptionSubject$ = this._authService.profileDetails
        .pipe(takeUntilDestroyed(this.destroyRef$))
        .subscribe({  
          next: (res: LoginResponse | null) => {
            if (res) {
              this.profile.set(res);
            } else {
             
              if(isPlatformBrowser(this.platformId)){
                this.getProfile();
              }
            }
          },
        });
  }

  menuItems: any[] = [];
  menuItems2: any[] = [];
  footerMenuItems: any[] = [];

  studentmenuItems = [
    { label: 'My Tests', icon: this.assetsConst.sidebarIcon, path: '/my-tests' },
    { label: 'My Report & Progress', icon: this.assetsConst.sidebarIcon2, path: '/students/reports' },
  ];

  studentmenuItems2 = [
    { label: 'Purchase History', icon: this.assetsConst.sidebarIcon3, path: '/purchase-history' },   
  ];

  studentmenuItems3 = [
    { label: 'Help & Support', icon: this.assetsConst.sidebarIcon4, path: '/support/help-center' },
    { label: 'Change Password', icon: this.assetsConst.lockIcon, path: '/account/change-password' },
    { label: 'About Platform', icon: this.assetsConst.sidebarIcon5, path: '/support/about-platform' },
    { label: 'Terms & Conditions', icon: this.assetsConst.sidebarIcon6, path: '/support/terms-and-conditions' },
    { label: 'Privacy Policy', icon: this.assetsConst.sidebarIcon7, path: '/support/privacy-policy' },
    { label: 'Logout', icon: this.assetsConst.sidebarIcon8, path: null, action: 'logout' },
  ];
  businessMemberMenuItems = [
    { label: 'My Tests', icon: this.assetsConst.sidebarIcon, path: '/my-tests' },
    { label: 'My Report & Progress', icon: this.assetsConst.sidebarIcon2, path: '/students/reports' },
  ];
    businessmembermenuItems2 = [
     { label: 'Help & Support', icon: this.assetsConst.sidebarIcon4, path: '/support/help-center' },   
  ];
  businessMemberFooterItems = [
    { label: 'Change Password', icon: this.assetsConst.lockIcon, path: '/account/change-password' },
    { label: 'About Platform', icon: this.assetsConst.sidebarIcon5, path: '/support/about-platform' },
    { label: 'Terms & Conditions', icon: this.assetsConst.sidebarIcon6, path: '/support/terms-and-conditions' },
    { label: 'Privacy Policy', icon: this.assetsConst.sidebarIcon7, path: '/support/privacy-policy' },
    { label: 'Logout', icon: this.assetsConst.sidebarIcon8, path: null, action: 'logout' },
  ];
  tutormenuItems = [
    { label: 'My Earnings', icon: this.assetsConst.sidebarIcon9, path: '/tutor/manage-earning' },
    // { label: 'Manage Students', icon: this.assetsConst.sidebarIcon2, path: '/tutor/manage-students' },
    { label: 'Manage MCQ Sets', icon: this.assetsConst.sidebarIcon10, path: '/mcq-sets' },
    { label: 'Analytics & Reports', icon: this.assetsConst.sidebarIcon11, path: '/tutor/my-progress' },
  ];

  tutormenuItems2 = [
    { label: 'Bank Details', icon: this.assetsConst.sidebarIcon12, path: '/tutor/bank-details' },   
  ];

  businessmenuItems = [
    { label: 'Purchased Sets/Test', icon: this.assetsConst.sidebarIcon, path: '/business/purchases' },
    { label: 'Members', icon: this.assetsConst.sidebarIcon2, path: '/business/members' },
    { label: 'Assignments ', icon: this.assetsConst.sidebarIcon10, path: '/business/assignments' },
    { label: 'Analytics & Reports', icon: this.assetsConst.sidebarIcon11, path: '/business/progress' },
  ];

  businessmenuItems2 = [
    { label: 'Invoices & Payments', icon: this.assetsConst.sidebar_icon3, path: '/purchase-history' },
  ];
private toUserType(value: string | null): UserType | null {
  if (value === 'student' ||
      value === 'tutor' ||
      value === 'business' ||
      value === 'business-member') {
    return value;
  }
  return null;
}

  ngOnInit() {
      const stored = localStorage.getItem('userType'); // string | null
  this.userType = this.toUserType(stored); 
    if (this.userType === 'student') {
      this.menuItems = [...this.studentmenuItems];
      this.menuItems2 = [...this.studentmenuItems2];
      this.footerMenuItems = [...this.studentmenuItems3];
    } else if (this.userType === 'business-member') {
      this.menuItems = [...this.businessMemberMenuItems];
      this.menuItems2 = [...this.businessmembermenuItems2];
      this.footerMenuItems = [...this.businessMemberFooterItems];
    }
     else if (this.userType === 'tutor') {
      this.menuItems = [...this.tutormenuItems];
      this.menuItems2 = [...this.tutormenuItems2];
      this.footerMenuItems = [
        { label: 'Help & Support', icon: this.assetsConst.sidebarIcon4, path: '/support/help-center' },
        { label: 'Change Password', icon: this.assetsConst.lockIcon, path: '/account/change-password' },
        { label: 'About Platform', icon: this.assetsConst.sidebarIcon5, path: '/support/about-platform' },
        { label: 'Terms & Conditions', icon: this.assetsConst.sidebarIcon6, path: '/support/terms-and-conditions' },
        { label: 'Privacy Policy', icon: this.assetsConst.sidebarIcon7, path: '/support/privacy-policy' },
        { label: 'Logout', icon: this.assetsConst.sidebarIcon8, path: null, action: 'logout' },
      ]; 
    } else {
      this.menuItems = [...this.businessmenuItems];
      this.menuItems2 = [...this.businessmenuItems2];
      this.footerMenuItems = [
        { label: 'Help & Support', icon: this.assetsConst.sidebarIcon4, path: '/support/help-center' },
        { label: 'Change Password', icon: this.assetsConst.lockIcon, path: '/account/change-password' },
        { label: 'About Platform', icon: this.assetsConst.sidebarIcon5, path: '/support/about-platform' },
        { label: 'Terms & Conditions', icon: this.assetsConst.sidebarIcon6, path: '/support/terms-and-conditions' },
        { label: 'Privacy Policy', icon: this.assetsConst.sidebarIcon7, path: '/support/privacy-policy' },
        { label: 'Logout', icon: this.assetsConst.sidebarIcon8, path: null, action: 'logout' },
      ]; 
    }
  }

  private getProfile(): void {
    this._authService
      .getProfile()
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe((res: LoginResponse | null) => {
        if (res) {      
          this.profile.set(res);
          this._authService.profileDetails.next(res);
        }
      });
  }

  get profileLink(): string {
    switch(this.userType) {
      case 'student':
        return '/account/my-profile';
      case 'business':
        return '/business/my-profile';
      case 'tutor':
        return '/tutor/my-profile';
      default:
        return '/account/my-profile';
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // onMenuItemClick(item: any, event?: Event): void {
  //   this.menuSelected.next(false);
  //   if (item.action === 'logout') {
  //     this.btn_logOut();
  //   }
  // }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onMenuItemClick(item: any, event?: Event): void {
    
    // 1. Navigate Programmatically first
    if (item.path && item.action !== 'logout') {
      this.router.navigate([item.path]);
    }

    // 2. Then close the drawer
    this.menuSelected.next(false);

    // 3. Handle logout if needed
    if (item.action === 'logout') {
      this.btn_logOut();
    }
  }
    onMenuClose(): void {
    this.menuSelected.next(false);
  }


 btn_logOut(): void {
    this.confirmationService
      .showConfirmationDialog(' ', this._translateService.instant('SureLogout'))
      .then((result) => {
        if (result) {
          this._authService.logout()
            .pipe(takeUntil(this.destroy))
            .subscribe({
              next: () => {
                localStorage.removeItem(environment.storageKey);
                this.profile.set(null);
                this._authService.profileDetails.next(null);
                this.router.navigate(['/landing-page']);
              },
            });
        }
      });
  }


  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
